export default {
  SETTINGS: 'c9dbd82e-3371-4ee3-9809-86d4aca6fdf4',
  GENERAL: 'c0fc21b0-53eb-45e1-a7c1-c2b0206bd35b',
  SOCIAL_AND_COMMUNITY: 'a6d50676-c5b7-4e6b-b180-e2d261ffd055',
  POLICIES: '3aaeb1e0-4bf8-4b6a-8776-7554a2a41da5',
  HOW_TO: 'a5f57bae-b654-40f3-beeb-a6534384c4fb',
  PRIVACY_POLICY_EXAMPLE: '8fc26161-5152-45d5-817b-2b5a1787cd71',
  TERMS_OF_USE_EXAMPLE: '9a7ef876-7196-434f-803b-a399eb55897b',
};
